
import React from 'react';
import { ComplianceNotificationSystem } from '@/components/admin/certificates/ComplianceNotificationSystem';
import { ExtendedHelp } from '@/components/admin/certificates/ContextualHelp';

export function RetentionHeader() {
  return (
    <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
      <div>
        <h1 className="text-2xl font-bold">Retention Management</h1>
        <p className="text-muted-foreground">
          Manage data retention policies and archive records
        </p>
      </div>
      
      <div className="flex items-center gap-2">
        <ComplianceNotificationSystem />
        
        <ExtendedHelp 
          topic="retention-policy" 
          buttonText="Retention Guide" 
          size="lg" 
          className="ml-2"
        />
      </div>
    </div>
  );
}
